const formatPhone = (phone: string | null, isPeruPhone = false, isColombiaPhone = false): string => {
  if (!phone) return '';
  let formattedPhone = phone.replace(/[\s()+-]/g, ''); // remove spaces and +
  formattedPhone = formattedPhone.replace(/^0+/, ''); // Remove zeros at the beginning

  if (isPeruPhone) {
    if (formattedPhone.length === 9) {
      formattedPhone = `51${formattedPhone}`;
    } else if (formattedPhone.length === 8) {
      formattedPhone = `519${formattedPhone}`;
    }
    return formattedPhone;
  }

  if (isColombiaPhone) {
    if (formattedPhone.length === 10 && formattedPhone.startsWith('3')) {
      formattedPhone = `57${formattedPhone}`;
    } else if (formattedPhone.length === 9) {
      formattedPhone = `573${formattedPhone}`;
    }
    return formattedPhone;
  }

  if (formattedPhone.length === 8) {
    formattedPhone = `569${formattedPhone}`;
  } else if (formattedPhone.length === 9 && formattedPhone.startsWith('9')) {
    formattedPhone = `56${formattedPhone}`;
  } else if (formattedPhone.length === 9 && formattedPhone.startsWith('2')) {
    formattedPhone = `56${formattedPhone}`;
  } else if (formattedPhone.length === 10 && formattedPhone.startsWith('56')) {
    formattedPhone = `569${formattedPhone.slice(2)}`;
  } else if (formattedPhone.length === 13 && formattedPhone.startsWith('5656')) {
    formattedPhone = formattedPhone.slice(2);
  } else if (formattedPhone.length === 12 && formattedPhone.startsWith('5699')) {
    formattedPhone = `569${formattedPhone.slice(4)}`;
  } else if (formattedPhone.length === 14 && formattedPhone.startsWith('56956')) {
    formattedPhone = formattedPhone.slice(3);
  }

  if (formattedPhone.length === 12 && formattedPhone.startsWith('5609')) {
    formattedPhone = `56${formattedPhone.slice(3)}`; // remove the '0', common error
  }
  return formattedPhone;
};

export default formatPhone;
